import Vue from 'vue'
import Vuex from 'vuex'

// MODULES
import global from './modules/global'
import hosted from './modules/hosted'
import payments from './modules/payments'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: true,
  modules: {
    global,
    hosted,
    payments
  }
})
